export default {
    methods: {
        postMessage (message) {
            if (window.androidNativeObj) {
                window.androidNativeObj.postMessage(JSON.stringify(message))
            } else if (window.webkit) {
                window.webkit.messageHandlers.WebSign.postMessage(JSON.stringify(message))
            } else {
                window.alert(JSON.stringify(message))
            }
        }
    }
}